import { render, staticRenderFns } from "./severity_badge.vue?vue&type=template&id=7eea0d97&"
import script from "./severity_badge.vue?vue&type=script&lang=js&"
export * from "./severity_badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports